import { CATALOGS, type Locale } from './catalog';

/**
 * Percentage of the English key set each locale actually translates.
 *
 * Lives outside `catalog.ts` on purpose: `scripts/i18n/check-coverage.mjs`
 * strips the types off that file and evaluates it, so the catalog has to stay
 * erasable syntax: string maps and type aliases only. Any real code there
 * breaks the CI coverage gate.
 *
 * Computed from the catalogs themselves so it can never drift. The locale
 * picker uses it to say "isiZulu (65% translated)" rather than offering a
 * language that silently falls back to English for a third of the console
 * (_UI_improvements/tenant/_app-shell.md §4 item 7).
 */
export function localeCoverage(code: Locale): number {
  const total = Object.keys(CATALOGS.en).length;
  if (code === 'en' || total === 0) return 100;
  const translated = Object.keys(CATALOGS.en).filter((key) => {
    const value = CATALOGS[code][key];
    return typeof value === 'string' && value.length > 0;
  }).length;
  return Math.round((translated / total) * 100);
}
